export default __webpack_public_path__ + "static/media/auth_bottom.dd6d4ab7.svg";